export const RESET_STATE = 'RESET_STATE';

export const LISTAGEM_FATURAMENTO_LOADING = 'LISTAGEM_FATURAMENTO_LOADING';
export const LISTAGEM_FATURAMENTO = 'LISTAGEM_FATURAMENTO';
export const LISTAGEM_FATURAMENTO_ERRO = 'LISTAGEM_FATURAMENTO_ERRO';

export const LISTAGEM_DETALHAMENTO_FATURAMENTO_LOADING = 'LISTAGEM_DETALHAMENTO_FATURAMENTO_LOADING';
export const LISTAGEM_DETALHAMENTO_FATURAMENTO = 'LISTAGEM_DETALHAMENTO_FATURAMENTO';
export const LISTAGEM_DETALHAMENTO_FATURAMENTO_ERRO = 'LISTAGEM_DETALHAMENTO_FATURAMENTO_ERRO';

export const DETALHAMENTO_FATURAMENTO_LOADING = 'DETALHAMENTO_FATURAMENTO_LOADING';
export const DETALHAMENTO_FATURAMENTO = 'DETALHAMENTO_FATURAMENTO';
export const DETALHAMENTO_FATURAMENTO_ERRO = 'DETALHAMENTO_FATURAMENTO_ERRO';